<template>
  <div class="body-container">
    <div :class="{ 'signIn-container border-container align-items-center d-inline-grid': eventType != 'joinStudy' }" v-if="modes[mode] == 'CARD' || mode == undefined">
      <div class="d-flex justify-content-center">
        <div class="text-center forgot-container" id="selectCountry">
          <div v-if="!isChangeConfirmed" class="language-box">
            <div class="language-title" v-translate:pweb_title_language_country_setting="lang">Language and Country Settings</div>
            <div class="form-group pt-55">
              <label v-translate:profile_language_title="lang">Language</label>
              <select class="form-control input-md activity-type" aria-required="true" aria-invalid="false" v-model="language" @change="selectLanguage">
                <option
                  v-for="(lang1, i) in languages"
                  :key="i"
                  :value="lang1.language_id"
                  :selected="lang1.language_id == language"
                  v-translate:dynamic_string="{
                    key: `LANGUAGE_${lang1.language_culture}`,
                    val: lang1,
                    html: lang1.display_name
                  }"
                  >{{ lang1.display_name }}</option
                >
              </select>
            </div>
            <div class="form-group pt-30">
              <label v-translate:country_title="lang">Country</label>
              <select class="form-control input-md activity-type" aria-required="true" aria-invalid="false" v-model="country" @change="selectCountry">
                <option
                  v-for="(count, i) in countries"
                  :key="i"
                  :value="count.countryId"
                  :selected="count.countryId == country"
                  v-translate:dynamic_string="{
                    key: `COUNTRY_${count.countryName.toUpperCase().replace(' ', '_')}`,
                    val: lang,
                    html: count.countryName
                  }"
                  >{{ count.countryName }}</option
                >
              </select>
            </div>
            <div class="form-group pt-48">
              <button class="btn btn-submit primary-bg" @click="isChangeConfirmed = true" v-translate:btn_save_title="lang">Save</button>
            </div>
          </div>
          <div v-else class="language-box">
            <span class="language-title" v-html="warningText"></span>
            <div class="language-content">
              <p class="comfirmation-text" v-html="displayConfirmMessage"></p>
            </div>
            <div class="row lang-btn-group">
              <div class="col-12 col-md-12 p-0 mb-15">
                <button class="btn leave_study_cntue primary-bg" @click="getLanugageStatic" v-html="yesText"></button>
              </div>
              <div class="col-12 col-md-12 p-0">
                <button class="btn leavestudy text-white primary-bg" @click="isChangeConfirmed = false" v-html="noText"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="mode == 'NAV'" class="col-md-12 p-0">
      <div class="d-inline-flex align-items-end">
        <div class="dropdown-wrap">
          <i aria-hidden="true" class="fa fa-globe text-white globe"></i>
          <select class="common_dropdown" v-model="country" @change="selectCountry">
            <option
              v-for="(count, i) in countries"
              :key="i"
              :value="count.countryId"
              :selected="count.countryId === country"
              v-translate:dynamic_string="{
                key: `COUNTRY_${count.countryName.toUpperCase().replace(' ', '_')}`,
                val: lang,
                html: count.countryName
              }"
              >{{ count.countryName }}</option
            >
          </select>
        </div>
        <div class="dropdown-wrap ml-8">
          <i aria-hidden="true" class="fa fa-globe text-white globe"></i>
          <select class="common_dropdown language_dropdown" v-model="language" @change="selectLanguage">
            <option
              v-for="(lang, i) in languages"
              :key="i"
              :value="lang.language_id"
              :selected="lang.language_id == language"
              v-translate:dynamic_string="{
                key: `LANGUAGE_${lang.language_culture}`,
                val: lang,
                html: lang.display_name
              }"
              >{{ lang.display_name }}</option
            >
          </select>
        </div>
      </div>
    </div>
    <cookieSettingsModal ref="cookieSettingsModal" platformType="pweb"> </cookieSettingsModal>
  </div>
</template>
<script>
import { ParticipantPortal, Widget } from "@/components/services/participant-service";
import moment from "moment";
import cookieSettingsModal from "@/components/auth/cookie-settings.vue";
import * as authService from "@/components/services/auth-service";

export default {
  name: "login",
  components: { cookieSettingsModal },
  props: {
    studyId: {},
    languageId: {},
    countryId: {},
    globalElement: {},
    mode: {},
    eventType: {},
    lang: { default: "en" }
  },
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      language: this.languageId,
      country: this.countryId,
      isChangeConfirmed: false,
      selectedStudyId: null,
      displayConfirmMessage: null,

      modes: ["CARD", "NAV"],
      warningText: "Are you sure?",
      noText: "No",
      yesText: "Yes",
      studyCountries: [],
      studyLanguages: []
    };
  },
  watch: {
    studyId(val) {
      this.selectedStudyId = val && val != 0 ? val : null;
    },
    isChangeConfirmed(val) {
      if (val) {
        this.warningText = this.widget.translate("ARE_YOU_SURE_TEXT", "Are you sure?");
        this.noText = this.widget.translate("NO_TEXT", "No");
        this.yesText = this.widget.translate("YES_TEXT", "Yes");
        let selectedLanguage = this.languages.find(o => o.language_id == this.language);
        let displayMessage = this.widget.translate("LANGUAGE_CONFIRMATION_DESCRIPTION2", `This will be the country and language you will use to conduct the entire study. You will not be able to change this once you register.\n\nAre you sure you want to continue with [langID] in [countryID]?`).replace("\\n\\n", "\n\n");
        let infoMessage = displayMessage.replace("\n\n", "<br><br>").trim();
        this.displayConfirmMessage = infoMessage
          .replace("[langID]", `<span class="confirm-text-bold">${this.widget.translate("LANGUAGE_" + selectedLanguage.language_culture, selectedLanguage.display_name)}</span>`)
          .replace("[countryID]", `<span class="confirm-text-bold">${this.widget.translate("COUNTRY_" + this.defaultCountry.countryName.toUpperCase().replace(" ", "_"), this.defaultCountry.countryName)}</span>`);
      }
    }
  },
  computed: {
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    countries() {
      let countries = this.selectedStudyId ? this.studyCountries.map(this.portal.mapCountry) : this.$store.getters.getParticipantCountries;
      return countries || [];
    },
    languages() {
      let languages = this.selectedStudyId ? this.studyLanguages : this.$store.getters.getParticipantLanguages;
      return languages || [];
    },
    defaultCountry() {
      let country = null;
      if (this.country) {
        country = this.countries.find(it => it.countryId == this.country);
      } else {
        country = this.$store.getters.getParticipantCountries.find(it => it.default);
      }
      return country;
    },
    defaultLanguage() {
      let language = null;
      if (this.language) {
        language = this.languages.find(it => it.language_id == this.language);
      } else {
        language = this.$store.getters.getParticipantLanguages.find(it => it.is_default);
      }
      return language;
    }
  },
  mounted() {
    this.$emit("setHeaderOptions", null);
    /** Country & Language Settings */
    this.language = this.portal.getLanguage() ? this.portal.getLanguage() : this.defaultLanguage.language_id;
    this.country = this.portal.getCountry() ? this.portal.getCountry() : this.defaultCountry.countryId;
    this.selectedStudyId = this.studyId && this.studyId != 0 ? this.studyId : null;
    this.isStudySelected = this.studyId !== "0";
    this.setSelectedStudyLanguageCountries();
    this.setSelectedStudyCountryLanguages();
    /** Country & Language Settings */
    this.checkCookiePreference();
  },
  methods: {
    setSelectedStudyLanguageCountries() {
      if (this.selectedStudyId) {
        this.$api.getAvailableCountryConfiguration(this.selectedStudyId, this.portal.getVersion(), this.language).then(res => {
          this.studyCountries = res.body.filter(it => !it.havingOnlyDraftLanguage);
        });
      }
    },
    setSelectedStudyCountryLanguages() {
      if (this.selectedStudyId) {
        this.$api.getAvailableLanguagesConfiguration(this.selectedStudyId, this.portal.getVersion(), this.country).then(res => {
          this.studyLanguages = res.body.filter(it => !it.draft);
        });
      }
    },
    selectLanguage(event) {
      this.language = event.target.value;
      this.setSelectedStudyLanguageCountries();
      this.pullStaticKeys(false);
      if (this.mode == "NAV") {
        this.getLanugageStatic();
      }
    },
    selectCountry(event) {
      this.country = event.target.value;
      this.setSelectedStudyCountryLanguages();
      if (this.mode == "NAV") {
        this.getLanugageStatic();
      }
    },
    getLanugageStatic() {
      if (this.portal && this.portal.studyDetails && this.portal.studyDetails.countryId && this.portal.studyDetails.languageId && this.portal.studyDetails.studyId && this.portal.studyDetails.version && this.portal.studyDetails.languageId == this.language && this.portal.studyDetails.countryId == this.country) {
        this.$emit("updateActiveScreen", "joinIntro");
        this.pullStaticKeys(true);
      } else {
        this.pullStaticKeys(true);
      }
    },
    pullStaticKeys(isLoginPage = true) {
      this.$api.getStaticLanguages(this.language).then(
        response => {
          let mappedStrings = [];
          let selectedLang = this.languages.find(o => o.language_id == this.language);
          this.lang = selectedLang && selectedLang.language_culture;
          moment.locale(this.lang);
          response.data.forEach(o => {
            mappedStrings[o.resourceKey] = o.resourceValue;
          }, mappedStrings);
          this.$store.dispatch("setParticipantsPortalLanguageTranslation", mappedStrings);
          this.portal.setLocalStorage("pw-languageId", this.language);
          this.portal.setLocalStorage("pw-countryId", this.country);
          if (this.lang !== "EN" || this.lang !== "en") {
            this.portal.getBitriseDataTranslation();
            if (this.portal.getStudy()) {
              this.widget.getActivityTranslation(this.portal.getStudy(), this.lang);
            }
          }
          /** To Do - Take Participant to Login Page */
          if (isLoginPage) {
            this.$emit("updateLanguage", this.language);
            this.$emit("updateCountry", this.country);
            this.$store.dispatch("setParticipantsPortalLanguages", selectedLang);
            if (this.portal && this.portal.studyDetails && this.portal.studyDetails.countryId && this.portal.studyDetails.languageId && this.portal.studyDetails.studyId && this.portal.studyDetails.version && this.portal.studyDetails.languageId == this.language && this.portal.studyDetails.countryId == this.country) {
              this.$emit("updateActiveScreen", "joinIntro");
            }
          }
        },
        error => {
          let message = this.widget.translate(error.message, "Problem in fetching language translations.");
          this.$toastr.error(message);
        }
      );
    },
    openCookieSettingsModal() {
      this.$refs.cookieSettingsModal.show();
    },
    checkCookiePreference() {
      let isCookiesAccepted = authService.getCookiePreference("pweb");
      if (!isCookiesAccepted) {
        this.openCookieSettingsModal();
      }
    }
  }
};
</script>
<style scoped="scss">
.common_dropdown {
  width: 190px;
  background-color: gray;
  margin: 0;
  padding: 3px 7px 4px 26px;
  border-radius: 4px;
  border: none;
  line-height: 16px;
  font-size: 12px;
  display: block;
  height: 30px;
  color: #fff;
}
.language_dropdown {
  border-radius: 4px;
}
.globe {
  position: absolute;
  top: 6px;
  left: 6px;
  font-size: 18px;
  color: #fff;
}
.dropdown-wrap {
  position: relative;
}
</style>
